"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The names of the string constants you can use as HTML attributes for the <tableau-pulse> web component.
 * @ignore
 */
var PulseAttributes;
(function (PulseAttributes) {
    PulseAttributes["DisableExploreFilter"] = "disable-explore-filter";
    PulseAttributes["Layout"] = "layout";
    PulseAttributes["OnFirstInteractive"] = "onFirstInteractive";
    PulseAttributes["OnFirstPulseMetricSizeKnown"] = "onFirstPulseMetricSizeKnown";
    PulseAttributes["OnPulseUrlError"] = "onPulseError";
    PulseAttributes["OnPulseFiltersChanged"] = "onPulseFiltersChanged";
    PulseAttributes["OnPulseInsightDiscovered"] = "onPulseInsightDiscovered";
    PulseAttributes["OnPulseMetricSizeChanged"] = "onPulseMetricSizeChanged";
    PulseAttributes["OnPulseTimeDimensionChanged"] = "onPulseTimeDimensionChanged";
    PulseAttributes["OnPulseUrlChanged"] = "onPulseUrlChanged";
    PulseAttributes["TimeDimension"] = "time-dimension";
    PulseAttributes["TokenOptional"] = "token-optional";
})(PulseAttributes = exports.PulseAttributes || (exports.PulseAttributes = {}));
/**
 * The names of the string constants you can use as child tags for TableauPulse custom element.
 */
var PulseChildElements;
(function (PulseChildElements) {
    /**
     * Custom styles applicable to the embedded iframe element itself (not inside it).
     */
    PulseChildElements["IframeStyle"] = "iframe-style";
    /**
     * A parameter to be used in the Pulse theme.
     */
    PulseChildElements["ThemeParameter"] = "theme-parameter";
    /**
     * Contains a list of filter parameters.
     */
    PulseChildElements["PulseFilter"] = "pulse-filter";
})(PulseChildElements = exports.PulseChildElements || (exports.PulseChildElements = {}));
/**
 * The attributes of the child elements of <tableau-pulse>.
 */
var PulseChildElementAttributes;
(function (PulseChildElementAttributes) {
    PulseChildElementAttributes["Name"] = "name";
    PulseChildElementAttributes["Field"] = "field";
    PulseChildElementAttributes["Value"] = "value";
    PulseChildElementAttributes["Type"] = "type";
})(PulseChildElementAttributes = exports.PulseChildElementAttributes || (exports.PulseChildElementAttributes = {}));
//# sourceMappingURL=PulseInterfaces.js.map